import React from 'react';
import Label from 'components/Form/Label';
import { StyledTextInput } from './WizardStyled';

const TextInput = ({
  inputLabel,
  value,
  id,
  onChange,
  theme = 'default',
  small,
  disabled,
  icon,
  title,
}) => {
  return (
    <div>
      <Label theme={theme}>{inputLabel}</Label>
      <StyledTextInput
        theme={theme}
        id={id}
        small={small}
        type="text"
        value={value}
        onChange={(e) => onChange(e.target.value, id)}
        disabled={disabled}
        icon={icon}
        title={title}
      />
    </div>
  );
};

export default TextInput;
